import React from "react";
// import Listing from "./Listing";
import { Outlet } from "react-router-dom"; // Import Outlet


const Integrations = () => {
  return (
    <Outlet />
  );
};

export default Integrations;
